"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectRepositoryParameters = exports.RepositoryProvider = void 0;
const git_url_parse_1 = __importDefault(require("git-url-parse"));
var RepositoryProvider;
(function (RepositoryProvider) {
    RepositoryProvider["GitHub"] = "github";
    RepositoryProvider["GitLab"] = "gitlab";
    RepositoryProvider["BitBucket"] = "bitbucket";
})(RepositoryProvider = exports.RepositoryProvider || (exports.RepositoryProvider = {}));
function detectRepositoryParameters(url) {
    const parsed = git_url_parse_1.default(url);
    const commonParams = {
        git_url: parsed.href,
        owner: parsed.owner,
        name: parsed.name,
    };
    switch (true) {
        case parsed.source === 'github.com':
            return {
                provider: RepositoryProvider.GitHub,
                web_url: `https://github.com/${parsed.owner}/${parsed.name}`,
                ...commonParams,
            };
        case parsed.source === 'gitlab.com':
            return {
                provider: RepositoryProvider.GitLab,
                web_url: `https://gitlab.com/${parsed.owner}/${parsed.name}`,
                ...commonParams,
            };
        case parsed.source === 'bitbucket.org':
            return {
                provider: RepositoryProvider.BitBucket,
                web_url: `https://bitbucket.org/${parsed.owner}/${parsed.name}`,
                ...commonParams,
            };
        default:
            return null;
    }
}
exports.detectRepositoryParameters = detectRepositoryParameters;
//# sourceMappingURL=repository.js.map